import tw from 'twin.macro'

export const Button = tw.button`inline-flex text-black font-bold items-center space-x-2 leading-6 transition duration-150 ease-in-out hover:text-gray-900 focus:outline-none focus:text-gray-900`
export const Form = tw.div`float-right border-b col-2 h-10 px-5 pl-8 mr-20 text-sm  bg-transparent border-t-0 border-b border-l-0 border-r-0 rounded-none border-jungle focus:outline-none`
export const FormWrapper = tw.div`col-6 pr-8`
